export function retryAfterSeconds(value, now = Date.now()) {
    if (!value?.trim()) return null;

    const seconds = Number(value);
    if (Number.isFinite(seconds)) {
        return seconds >= 0 ? Math.ceil(seconds) : null;
    }

    const date = Date.parse(value);
    return Number.isFinite(date)
        ? Math.max(0, Math.ceil((date - now) / 1000))
        : null;
}

export class HttpResponseError extends Error {
    constructor(response) {
        const seconds = retryAfterSeconds(response.headers?.get('Retry-After'));
        const temporary = [429, 503].includes(response.status);
        const message = temporary
            ? seconds > 0
                ? `The service is temporarily busy. Please wait ${seconds} ${seconds === 1 ? 'second' : 'seconds'}, then try again.`
                : 'The service is temporarily busy. Please try again shortly.'
            : 'We could not complete your request. Please try again.';

        super(message);
        this.name = 'HttpResponseError';
        this.status = response.status;
        this.retryAfterSeconds = seconds;
    }
}

// Read bodies with readJsonResponse first so empty/HTML gateway errors cannot
// replace the HTTP failure with a JSON parsing exception. No request is replayed.
export function assertJsonResponse(response, data) {
    if (!response.ok || !data || typeof data !== 'object') {
        throw new HttpResponseError(response);
    }
}
